webpackJsonp([15],{

/***/ 524:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignupEmail_vue__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75169155_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignupEmail_vue__ = __webpack_require__(858);
function injectStyle (ssrContext) {
  __webpack_require__(855)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignupEmail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75169155_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignupEmail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 855:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(856);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(512)("4d755b7f", content, true);

/***/ }),

/***/ 856:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(511)(true);
// imports


// module
exports.push([module.i, ".profile__problem{margin-top:4em}.profile__problem>p{margin-bottom:.5em}", "", {"version":3,"sources":["/app/src/components/Profile/Signup/SignupEmail.vue"],"names":[],"mappings":"AAoHA,kBACE,cAAgB,CACjB,AACD,oBACI,kBAAqB,CACxB","file":"SignupEmail.vue","sourcesContent":["/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* Font\n-------------------------- */\n/* Element Chalk Variables */\n/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* 53a8ff */\n/* 66b1ff */\n/* 79bbff */\n/* 8cc5ff */\n/* a0cfff */\n/* b3d8ff */\n/* c6e2ff */\n/* d9ecff */\n/* ecf5ff */\n/* Link\n-------------------------- */\n/* Background\n-------------------------- */\n/* Border\n-------------------------- */\n/* Box-shadow\n-------------------------- */\n/* Fill\n-------------------------- */\n/* Font\n-------------------------- */\n/* Size\n-------------------------- */\n/* z-index\n-------------------------- */\n/* Disable base\n-------------------------- */\n/* Icon\n-------------------------- */\n/* Checkbox\n-------------------------- */\n/* Radio\n-------------------------- */\n/* Select\n-------------------------- */\n/* Alert\n-------------------------- */\n/* Message Box\n-------------------------- */\n/* Message\n-------------------------- */\n/* Notification\n-------------------------- */\n/* Input\n-------------------------- */\n/* Cascader\n-------------------------- */\n/* Group\n-------------------------- */\n/* Tab\n-------------------------- */\n/* Button\n-------------------------- */\n/* cascader\n-------------------------- */\n/* Switch\n-------------------------- */\n/* Dialog\n-------------------------- */\n/* Table\n-------------------------- */\n/* Pagination\n-------------------------- */\n/* Popover\n-------------------------- */\n/* Tooltip\n-------------------------- */\n/* Tag\n-------------------------- */\n/* Tree\n-------------------------- */\n/* Dropdown\n-------------------------- */\n/* Badge\n-------------------------- */\n/* Card\n--------------------------*/\n/* Slider\n--------------------------*/\n/* Steps\n--------------------------*/\n/* Menu\n--------------------------*/\n/* Rate\n--------------------------*/\n/* DatePicker\n--------------------------*/\n/* Loading\n--------------------------*/\n/* Scrollbar\n--------------------------*/\n/* Carousel\n--------------------------*/\n/* Collapse\n--------------------------*/\n/* Transfer\n--------------------------*/\n/* Header\n  --------------------------*/\n/* Footer\n--------------------------*/\n/* Main\n--------------------------*/\n/* Break-point\n--------------------------*/\n.profile__problem {\n  margin-top: 4em;\n}\n.profile__problem > p {\n    margin-bottom: 0.5em;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 857:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_notify_constants__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_webcall__ = __webpack_require__(30);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      form: {
        email: ''
      },
      rules: {
        email: [{ type: 'email', required: true, message: 'Please enter a valid email address', trigger: 'blur' }]
      },
      showVerification: false,
      loading: {
        updatingEmail: false,
        sendingVerification: false
      }
    };
  },

  computed: {
    needEmail: function needEmail() {
      return this.$store.state.account.shouldAskForAddingEmail;
    },
    needVerification: function needVerification() {
      return this.$store.state.account.shouldAskForVerification;
    },
    unverifiedEmail: function unverifiedEmail() {
      return this.$store.state.account.blob.unverified_email;
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;

      this.$refs.form.validate()
      // Stop execution if form is not valid
      .catch(function () {
        var errorMessage = 'Please enter a valid email address';
        _this.$alert(errorMessage, 'Error', {
          confirmButtonText: 'OK'
        });
        throw new Error(errorMessage);
      }).then(function () {
        _this.loading.updatingEmail = true;
        return __WEBPACK_IMPORTED_MODULE_1__libs_webcall__["a" /* default */].user.updateEmail(_this.form).catch(function (_ref) {
          var data = _ref.data;

          var errorMessage = data.error || 'We are unable to update the email now. Please check your internet connection or contact support.';
          _this.$alert(errorMessage, 'Opps');
          _this.loading.updatingEmail = false;
        });
      }).then(function () {
        _this.loading.updatingEmail = false;
        return _this.$store.dispatch('account/initialiseAccount').then(function () {
          _this.showVerification = _this.needVerification;
        });
      }).catch(function () {
        _this.loading.updatingEmail = false;
      });
    },
    resendVerificationEmail: function resendVerificationEmail() {
      var _this2 = this;

      this.loading.sendingVerification = true;
      __WEBPACK_IMPORTED_MODULE_1__libs_webcall__["a" /* default */].user.sendVerificationEmail().then(function () {
        _this2.loading.sendingVerification = false;
      }).catch(function (error) {
        _this2.$notify.error({
          title: 'Unable to resend verification',
          message: 'Please check your connection or try again later.',
          duration: __WEBPACK_IMPORTED_MODULE_0__config_notify_constants__["a" /* default */].DURATION.FOREVER
        });
        _this2.loading.sendingVerification = false;
      });
    }
  },
  mounted: function mounted() {
    this.form.email = this.unverifiedEmail;
    this.showVerification = this.needVerification;
  }
});

/***/ }),

/***/ 858:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile content-width"},[_c('h1',[_c('i',{staticClass:"el-icon-message"}),_vm._v(" "+_vm._s((_vm.showVerification) ? 'Verify your' : 'Add your')+" email address")]),_vm._v(" "),(_vm.showVerification)?_c('div',[_c('p',[_vm._v("\n      A verification email has been sent to "),_c('strong',[_vm._v(_vm._s(_vm.unverifiedEmail))]),_vm._v("."),_c('br'),_vm._v("\n      Please check your inbox and follow the instruction inside the email to\n      complete the sign up process.\n    ")]),_vm._v(" "),_c('div',{staticClass:"profile__problem"},[_vm._m(0),_vm._v(" "),_c('el-button-group',[_c('el-button',{attrs:{"size":"mini","icon":"el-icon-arrow-left"},on:{"click":function($event){_vm.showVerification = false}}},[_vm._v("\n          Change your email\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.resendVerificationEmail}},[_vm._v("\n          Resend verification email\n        ")])],1)],1)]):_c('div',[_c('p',[_vm._v("\n      To create your Viddsee creator account and to keep you updated on your\n      film, we will need your email address. Please enter your email below:\n    ")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.rules}},[_c('el-form-item',{attrs:{"prop":"email"}},[_c('el-input',{attrs:{"required":"","type":"email","placeholder":"Please enter a valid email address"},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}},[_c('el-button',{attrs:{"slot":"append","loading":_vm.loading.updatingEmail},on:{"click":_vm.submit},slot:"append"},[_vm._v("Add")])],1)],1)],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('small',[_vm._v("Didn't receive your email?")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// js/15.c17e7cb0e0537f1d2d83.js